import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { styled, Radio as MUIRadio, RadioGroup, FormControlLabel as MUIFormControlLabel, FormLabel as MUIFormLabel, FormControl, } from "@mui/material";
import { convertPxToRem } from "../../util-functions";
const StyledFormLabel = styled(MUIFormLabel)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.largeTextStrong), { color: theme.palette.primaryBlackText.main, "&.Mui-error": {
        color: theme.palette.error.main,
    }, "&.Mui-focused": {
        color: theme.palette.primaryBlackText.main,
    }, "&.Mui-disabled": {
        color: theme.palette.disabledText.main,
    } })));
const StyledFormControlLabel = styled(MUIFormControlLabel, {
    shouldForwardProp: (prop) => prop !== "disabled",
})(({ theme, disabled }) => ({
    // label
    "> span:nth-child(2)": Object.assign(Object.assign({}, theme.typography.largeText), { "&.Mui-disabled": {
            color: theme.palette.disabledText.main,
        } }),
    "&.MuiRadio-root": {
        "> span": {
            border: disabled
                ? `${convertPxToRem(1.5)} solid ${theme.palette.grey04.main}`
                : `${convertPxToRem(1.5)} solid ${theme.palette.grey05.main}`,
        },
    },
}));
const StyledRadio = styled(MUIRadio)({
    "&.MuiRadio-root": {
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
});
const RadioIcon = styled("span")(({ theme }) => ({
    backgroundColor: theme.palette.primaryWhite.main,
    border: `${convertPxToRem(1.5)} solid ${theme.palette.grey05.main}`,
    borderRadius: "50%",
    boxSizing: "border-box",
    height: convertPxToRem(20),
    width: convertPxToRem(20),
    "& .Mui-checked": {
        border: `${convertPxToRem(1.5)} solid ${theme.palette.sativaGreen.main}`,
    },
    "input:hover ~ &": {
        border: `${convertPxToRem(1.5)} solid ${theme.palette.grey07.main}`,
    },
    "input:disabled ~ &": {
        backgroundColor: theme.palette.grey03.main,
        border: `${convertPxToRem(1.5)} solid ${theme.palette.grey04.main}`,
    },
    "input:disabled:hover ~ &": {
        border: `${convertPxToRem(1.5)} solid ${theme.palette.grey04.main}`,
    },
    ".Mui-focusVisible &": {
        border: `${convertPxToRem(1.5)} solid ${theme.palette.primaryBlack.main}`,
    },
}));
const RadioCheckedIcon = styled("span")(({ theme }) => ({
    backgroundColor: theme.palette.sativaGreen.main,
    border: `${convertPxToRem(1.5)} solid ${theme.palette.sativaGreen.main}`,
    borderRadius: "50%",
    boxSizing: "border-box",
    height: convertPxToRem(20),
    width: convertPxToRem(20),
    "&:before": {
        display: "block",
        backgroundColor: theme.palette.primaryBlack.main,
        borderRadius: "50%",
        height: convertPxToRem(6),
        width: convertPxToRem(6),
        marginTop: "32%",
        marginLeft: "32%",
        content: '""',
    },
    ".Mui-focusVisible": {
        outline: `${convertPxToRem(1.5)} solid ${theme.palette.primaryBlack.main}`,
    },
}));
export const RadioButton = ({ defaultValue, disabled = false, error = false, hideGroupLabel = false, label, onChange, radioButtons = [], required, row = false, testId, }) => {
    const [selectedValue, setSelectedValue] = useState(defaultValue !== null && defaultValue !== void 0 ? defaultValue : "");
    const handleChange = (event) => {
        const target = event.target;
        setSelectedValue(target.value);
        if (onChange) {
            onChange();
        }
    };
    return (_jsxs(FormControl, Object.assign({ disabled: disabled, error: error, required: required }, { children: [!hideGroupLabel && (_jsx(StyledFormLabel, Object.assign({ id: label, "data-testid": testId && `label-${testId}` }, { children: label }))), _jsx(RadioGroup, Object.assign({ "aria-labelledby": label, "data-testid": testId, name: `${label}-group`, onChange: handleChange, value: selectedValue, row: row }, { children: radioButtons.map((button) => (_jsx(StyledFormControlLabel, { control: _jsx(StyledRadio, { disableRipple: true, checkedIcon: _jsx(RadioCheckedIcon, {}), icon: _jsx(RadioIcon, {}), inputProps: {
                            "aria-label": button.label,
                        } }), label: button.label, value: button.value, disabled: disabled }, button.value))) }))] })));
};
